import React from "react";
import styled from "styled-components";
import { Formik } from "formik";
import { getErrorMessage } from "../../../helpers/functions";
import { useSnackbar } from "notistack";
import EventService from "../../../services/EventService";
import FormField from "../../common/FormField/FormField";
import useLoader from "../../../hooks/useLoader";
import "./modal.scss";
import Draggable from "react-draggable";

const Polling = ({ pollModal, setPollModal }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();
  let storedData = localStorage.getItem("pollArray");

  let libraryArray = storedData ? JSON.parse(storedData) : [];
  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "update polling" });
      const payload = {
        ...values,
      };
      const response = await EventService.viewerPolling(payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setPollModal({ state: false });
      libraryArray.push(values?.pollText);
      localStorage.setItem("pollArray", JSON.stringify(libraryArray));
    }
  }

  /**
   * @description live poll inputs
   */

  const inputs = [
    {
      name: "pollText",
      label: "Question",
      type: "select",
    },
    { name: "pollAnswer", label: "Answer", type: "select" },
  ];

  return (
    <Draggable handle=".modal_header">
    <div className={`modalContainer ${pollModal?.state ? "show" : ""}`}>
      <div className="modal">
        <header className="modal_header">
          <h2 className="modal_header-title">Polling Draggable Window</h2>
          {/* <button className="close">
            <CloseModal
              src={require("../../../assets/images/closeModal.svg")}
              onClick={() => setPollModal({ state: false })}
            />
          </button> */}
        </header>
        <Formik
          initialValues={{
            viewerId: pollModal?.viewerId,
            eventId: pollModal?.eventId,
            pollText: "",
            pollAnswer: "",
          }}
          enableReinitialize
          validateOnBlur
          validateOnChange
          onSubmit={onFormSubmit}
        >
          {({
            values,
            handleChange,
            errors,
            handleSubmit,
            touched,
            setFieldValue,
            setFieldError,
            handleBlur,
          }) => (
            <StyledForm onSubmit={handleSubmit}>
              <main className="modal_content">
                {inputs.map((input, index) => (
                  <FormField
                    key={index}
                    menuItems={
                      input.name === "pollText"
                        ? pollModal?.userData?.map((item) => ({
                            label: item.question,
                            value: item.question,
                          }))
                        : input.name === "pollAnswer"
                        ? pollModal?.userData
                            ?.filter(
                              (item) => item.question === values?.pollText,
                            )[0]
                            ?.options.map((arr) => ({
                              label: arr,
                              value: arr,
                            }))
                        : [{ name: "none", label: "None" }]
                    }
                    {...{
                      input,
                      values,
                      handleChange,
                      errors,
                      handleSubmit,
                      touched,
                      setFieldValue,
                      setFieldError,
                      handleBlur,
                    }}
                  />
                ))}
              </main>
              <footer className="modal_footer">
                <button
                  className="submit"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                >
                  Submit
                </button>
                {/* <button
                  className="modal-close"
                  onClick={(e) => {
                    e.preventDefault();
                    setPollModal(false);
                  }}
                >
                  Cancel
                </button> */}
              </footer>
            </StyledForm>
          )}
        </Formik>
      </div>
    </div>
    </Draggable>
  );
};

export default Polling;

const StyledForm = styled.form``;
